import type { AppState, AuthSession, ConsentRecord, Role } from './models';

export const REQUIRED_TERMS_VERSION = '2026-07-01';
export const REQUIRED_PRIVACY_VERSION = '2026-07-01';

export function isSessionActive(session: AuthSession, now = new Date()): boolean {
  if (!session.authenticated || !session.expiresAt) return false;
  const expiresAt = new Date(session.expiresAt).getTime();
  return Number.isFinite(expiresAt) && expiresAt > now.getTime();
}
export function hasRequiredConsent(state: Pick<AppState, 'session' | 'consents'>): boolean {
  if (state.session.role !== 'parent') return true;
  return state.consents.some((record) => record.userId===state.session.userId && record.guardianConsent && record.termsVersion===REQUIRED_TERMS_VERSION && record.privacyVersion===REQUIRED_PRIVACY_VERSION);
}
export function canAccessRole(current: Role, allowed: Role[]): boolean { return allowed.includes(current); }
export function createConsent(userId: string, guardianConsent: boolean, marketingConsent: boolean): ConsentRecord {
  return { id:`consent_${Date.now()}`, userId, termsVersion:REQUIRED_TERMS_VERSION, privacyVersion:REQUIRED_PRIVACY_VERSION, guardianConsent, marketingConsent, agreedAt:new Date().toISOString() };
}
